export default class TextareaInput extends React.Component {
  constructor(props) {
    super();
    this.state = {
      value: props.value || '',
      focused: false
    };
  }

  render() {
    const { placeholder, required, name, field } = this.props
    const { value, focused } = this.state
    const classes = classNames({
      'show-labelholder': value,
      'focused': focused,
    }, 'labelholder')
    return (
      <div className={classes}
           data-label={placeholder || ''}>
        <textarea
               className="form-control"
               required={required && JSON.parse(required)}
               value={value || ''}
               onChange={this._input.bind(this)}
               onFocus={() => this.setState({focused: true})}
               onBlur={() => this.setState({focused: false})}
               name={name}
               placeholder={placeholder || ''}
               id={field}/>
      </div>
    );
  }

  _input(e) {
    this.setState({value: e.target.value})
  }

  _clear() {
    this.setState({value: null})
  }
}

TextareaInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  field: PropTypes.string.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  required: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ])
};

